<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'GIPolicy'
}

</script>



// WEBPACK FOOTER //
// src/Osm/GIPolicy/containers/GIPolicy.vue